import { useCallback, useState } from 'react'

import { mapFiltersToVariables } from './_Filters'

export const useExpensesInsightsFilters = () => {
  const [activeFilters, setActiveFilters] = useState<Record<string, unknown> | undefined>()

  /**
   * Transforms raw DataCollection filters into the format expected by InsightsWidgets.
   * Returns { filter: {...} } where filter contains all mapped filter values.
   *
   * Note: The DataCollection uses `employeeIds` and `status` as top-level query parameters,
   * but the shared InsightsWidgets component only reads the `filter` object.
   * Therefore, we map them to their corresponding filter object fields:
   * - `status` → `status` (StringFilter in ExpensesExpensableFilter)
   * - `employeeIds` → `owner` (IntegerFilter in ExpensesExpensableFilter)
   */
  const getInsightsFilters = useCallback(() => {
    if (!activeFilters) return undefined

    const { status, employeeIds, filter } = mapFiltersToVariables(activeFilters)

    return {
      filter: {
        ...filter,
        ...(status && { status: { in: status } }),
        ...(employeeIds && { owner: { in: employeeIds } }),
      },
    }
  }, [activeFilters])

  return {
    activeFilters,
    setActiveFilters,
    getInsightsFilters,
  }
}
